var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHandFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.047 2.933h23.413v23.413H-.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.132 9.355c0-.53.465-1.15 1.02-1.535.37-.256.82-.341 1.352-.257v6.39a.532.532 0 1 0 1.061 0V4.9c0-.53.58-1.065 1.275-1.065.697 0 1.061.536 1.061 1.065v1.065l-.004 7.456c0 .294.242.533.535.533.292 0 .561-.239.561-.533V3.302c0-.533.612-1.078 1.246-1.078.633 0 1.188.549 1.188 1.078v2.663l.04 7.456c0 .294.197.533.49.533s.575-.239.575-.533l.038-9.157c0-.033.68-.34 1.568.279.89.618 1.027 1.236 1.027 1.765v3.857c0 .212-.075 4.69 0 4.606.565-.635 1.384-1.085 2.458-1.35 1.612-.397 2.736.167 3.088 1.065.352.898-.186 1.458-.288 1.561-1.042 1.058-2.275 2.494-4.65 6.242-1.485 2.343-3.926 3.532-6.78 3.532-3.806 0-6.861-2.885-6.861-6.474V9.355z",
    fill: "#6173FE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHandFill);
export default __webpack_public_path__ + "static/media/icon-hand-fill.8ce7de4c.svg";
export { ForwardRef as ReactComponent };